// One request per key (e.g. `follow:${userId}`) at a time, plus a short cooldown after it ends: a click while the
// previous request for the same target is running, or within COOLDOWN_MS after it finished, is ignored. The first click
// goes out at once and the reply is used as is. Usage:
//   if (!coolDownBegin(key)) return;   ...request...   .finally(() => coolDownEnd(key));
const COOLDOWN_MS = 1000;

const busy = new Set();

function coolDownBegin(key) {
    if (busy.has(key)) return false;
    busy.add(key);
    return true;
}

function coolDownEnd(key) {
    setTimeout(() => busy.delete(key), COOLDOWN_MS);
}

export { coolDownBegin, coolDownEnd };
